/* tslint:disable */
/* eslint-disable */
/* @relayHash 615f2d4a813dab154c84a060de4d1a48 */

import { ConcreteRequest } from "relay-runtime";
export type BookingModal_courses_QueryVariables = {
    categoryUUID?: string | null;
    secondaryCategoryUUID?: string | null;
    name?: string | null;
};
export type BookingModal_courses_QueryResponse = {
    readonly courses: {
        readonly edges: ReadonlyArray<{
            readonly ident: number;
            readonly name: string;
            readonly price: number;
            readonly role: string | null;
            readonly category: {
                readonly uuid: string | null;
            } | null;
            readonly secondaryCategory: {
                readonly uuid: string | null;
            } | null;
            readonly backgroundCheck: boolean | null;
            readonly specificTerms: string | null;
        } | null> | null;
    } | null;
};
export type BookingModal_courses_Query = {
    readonly response: BookingModal_courses_QueryResponse;
    readonly variables: BookingModal_courses_QueryVariables;
};



/*
query BookingModal_courses_Query(
  $categoryUUID: UUID
  $secondaryCategoryUUID: UUID
  $name: String
) {
  courses(filter: {categoryUUID: $categoryUUID, secondaryCategoryUUID: $secondaryCategoryUUID, searchText: $name}, page: {limit: 200}, orderBy: {ascending: false, field: "priority"}) {
    edges {
      __typename
      ident: id
      name
      price
      role
      category {
        uuid
      }
      secondaryCategory {
        uuid
      }
      backgroundCheck
      specificTerms
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "categoryUUID",
            "type": "UUID",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "secondaryCategoryUUID",
            "type": "UUID",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "name",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "ObjectValue",
            "name": "filter",
            "fields": [
                {
                    "kind": "Variable",
                    "name": "categoryUUID",
                    "variableName": "categoryUUID"
                },
                {
                    "kind": "Variable",
                    "name": "searchText",
                    "variableName": "name"
                },
                {
                    "kind": "Variable",
                    "name": "secondaryCategoryUUID",
                    "variableName": "secondaryCategoryUUID"
                }
            ]
        } as any),
        ({
            "kind": "Literal",
            "name": "orderBy",
            "value": {
                "ascending": false,
                "field": "priority"
            }
        } as any),
        ({
            "kind": "Literal",
            "name": "page",
            "value": {
                "limit": 200
            }
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": "ident",
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "price",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "role",
        "args": null,
        "storageKey": null
    } as any), v6 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "uuid",
            "args": null,
            "storageKey": null
        } as any)
    ], v7 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "category",
        "storageKey": null,
        "args": null,
        "concreteType": "Category",
        "plural": false,
        "selections": (v6 /*: any*/)
    } as any), v8 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "secondaryCategory",
        "storageKey": null,
        "args": null,
        "concreteType": "SecondaryCategory",
        "plural": false,
        "selections": (v6 /*: any*/)
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "backgroundCheck",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "specificTerms",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "BookingModal_courses_Query",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "courses",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CoursePage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "BookingModal_courses_Query",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "courses",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CoursePage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "__typename",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "BookingModal_courses_Query",
            "id": null,
            "text": "query BookingModal_courses_Query(\n  $categoryUUID: UUID\n  $secondaryCategoryUUID: UUID\n  $name: String\n) {\n  courses(filter: {categoryUUID: $categoryUUID, secondaryCategoryUUID: $secondaryCategoryUUID, searchText: $name}, page: {limit: 200}, orderBy: {ascending: false, field: \"priority\"}) {\n    edges {\n      __typename\n      ident: id\n      name\n      price\n      role\n      category {\n        uuid\n      }\n      secondaryCategory {\n        uuid\n      }\n      backgroundCheck\n      specificTerms\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '7f2ea705979d69f59f563f4ccd9ca0a3';
export default node;
